module.exports = __webpack_public_path__ + "img/904081517.04241d03.jpg";